/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advanced_Pro_Studio_LayoutInputs */

const en_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Pro Studio Layout`)
};

const es_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño Avanzado Pro Studio`)
};

const fr_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en page Avancée Pro Studio`)
};

const de_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweitertes Pro Studio Layout`)
};

const ja_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高度なプロスタジオレイアウト`)
};

const zh_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级专业工作室排版`)
};

const ar_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخطيط استوديو احترافي متقدم`)
};

const id_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tata Letak Pro Studio Lanjutan`)
};

const it_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout Avanzato Pro Studio`)
};

const ru_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продвинутый Макет Pro Studio`)
};

const pt_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Avançado Pro Studio`)
};

const ko_advanced_pro_studio_layout = /** @type {(inputs: Advanced_Pro_Studio_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고급 프로 스튜디오 레이아웃`)
};

/**
* | output |
* | --- |
* | "Advanced Pro Studio Layout" |
*
* @param {Advanced_Pro_Studio_LayoutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const advanced_pro_studio_layout = /** @type {((inputs?: Advanced_Pro_Studio_LayoutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advanced_Pro_Studio_LayoutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_advanced_pro_studio_layout(inputs)
	if (locale === "es") return es_advanced_pro_studio_layout(inputs)
	if (locale === "fr") return fr_advanced_pro_studio_layout(inputs)
	if (locale === "de") return de_advanced_pro_studio_layout(inputs)
	if (locale === "ja") return ja_advanced_pro_studio_layout(inputs)
	if (locale === "zh") return zh_advanced_pro_studio_layout(inputs)
	if (locale === "ar") return ar_advanced_pro_studio_layout(inputs)
	if (locale === "id") return id_advanced_pro_studio_layout(inputs)
	if (locale === "it") return it_advanced_pro_studio_layout(inputs)
	if (locale === "ru") return ru_advanced_pro_studio_layout(inputs)
	if (locale === "pt") return pt_advanced_pro_studio_layout(inputs)
	return ko_advanced_pro_studio_layout(inputs)
});